"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const imageRef = useRef<HTMLDivElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setMousePosition({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section className="relative min-h-screen w-full overflow-hidden bg-background">
      <div className="grid min-h-screen lg:grid-cols-2">
        {}
        <div className="relative h-[50vh] lg:h-screen overflow-hidden">
          <div ref={imageRef} className="absolute inset-0 bg-cover bg-center transition-transform duration-300 ease-out" style={{
          backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1518904/img/luxury_estate_hero.png)",
          transform: `translate(${mousePosition.x}px, ${mousePosition.y}px) scale(1.1)`
        }} />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background/20 lg:to-background/40" />
        </div>

        {}
        <div ref={contentRef} className="flex items-center justify-center px-6 py-16 lg:px-12 lg:py-0">
          <div className={`max-w-xl transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="text-4xl font-display font-bold text-foreground mb-6 lg:text-5xl xl:text-6xl leading-tight">
              Exclusive Estate Management for Discerning Clients
            </h1>
            
            <p className="text-lg mb-8 leading-relaxed !text-[hsl(0,0%,100%)]">
              Omni Wealth Management delivers discreet, full-service property oversight for luxury residential estates in Los Angeles. Experience personalized attention and meticulous stewardship.
            </p>

            <Link to="#contact">
              <Button size="lg" className="group shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] hover:scale-[1.02]">
                Explore Our Services
                <ArrowRight className="ml-2 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1" />
              </Button>
            </Link>

            <div className="mt-12 flex items-center gap-8 text-sm text-muted-foreground">
              <div className="flex flex-col">
                <span className="text-2xl font-display font-semibold text-foreground">15+</span>
                <span className="!text-[hsl(0,0%,100%)]">Years Experience</span>
              </div>
              <div className="h-12 w-px bg-border" />
              <div className="flex flex-col">
                <span className="text-2xl font-display font-semibold text-foreground">100%</span>
                <span className="!text-[hsl(0,0%,100%)]">Client Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}